define(['jquery', 'app/global', 'app/tools'], function ($, global, tools) {

  var $headerSearch = global.cache.$headerSearch,
    messageTemplate = '<div class="ajax-search__block">{text}</div>',
    messages = {
      searching: 'Trwa wyszukiwanie&hellip;',
      noResult: 'Podana fraza nie została odnaleziona. Spróbuj zmodyfikować swoje zapytanie.',
      noText: 'Podaj szukaną frazę.',
      noConnection: 'Sprawdź swoje połączenie z internetem.',
      error: 'Wystąpił błąd: {text}.'
    },
    resultsPresent = false,
    $headerSearchText,
    $ajaxSearchResult,
    $ajaxSearchClose,
    $ajaxSearchMain,
    ajaxPath;


  function giveMessage(innerHtml) {
    return tools.substitute(messageTemplate, {
      text: innerHtml
    });
  }

  function hideSearch() {
    $headerSearch.removeClass('open');
  }

  function getAjax(e) {
    var _value = e.target.value;
    // console.log(_value);
    if (_value !== '') {
      $headerSearch.addClass('open searching');
      $ajaxSearchMain.html(giveMessage(messages.searching));
      global.cache.$html.one('click.search', hideSearch);
      tools.ajax({
        url: ajaxPath,
        abort: true,
        ajaxName: 'ajax-search',
        data: $headerSearch.serialize(),
        cache: true,
        successCallback: function (response) {
          setTimeout(function () {
            // 2DO timeout testowo, potem kasujemy, a może nie :)
            $headerSearch.removeClass('searching');
            if (response.trim() === '') {
              resultsPresent = false;
              $ajaxSearchMain.html(giveMessage(messages.noResult));
            } else {
              resultsPresent = true;
              $ajaxSearchMain.html(response);
            }
          }, 250);
        },
        failCallback: function () {
          resultsPresent = false;
        },
        noConnectionCallback: function () {
          $ajaxSearchMain.html(giveMessage(messages.noConnection));
        },
        normalErrorCallback: function (jqXhr) {
          $ajaxSearchMain.html(giveMessage(tools.substitute(messages.error, {
            text: jqXhr.status
          })));
        }
      });
    } else {
      resultsPresent = false;
      $ajaxSearchMain.html(giveMessage(messages.noText));
    }
  }

  function setEvents() {

    $headerSearch.on('click', function (e) {
      e.stopImmediatePropagation();
    });

    $headerSearchText.on('focus', function () {
        if (resultsPresent) {
          $headerSearch.addClass('open');
          global.cache.$html.one('click.search', hideSearch);
        }
      })
      .on('keydown', tools.debounce(getAjax, 1000));

    $ajaxSearchResult.on('click', function (e) {
      e.stopImmediatePropagation();
    });

    $ajaxSearchClose.on('click', function (e) {
      resultsPresent = false;
      $headerSearchText.val('');
      hideSearch();
      global.cache.$html.off('click.search');
      e.preventDefault();
    });

  }

  if ($headerSearch) {
    $headerSearchText = $('#header-search-text');
    $ajaxSearchResult = $('#ajax-search-result');
    $ajaxSearchClose = $('#ajax-search-close');
    $ajaxSearchMain = $('#ajax-search-main');
    ajaxPath = $headerSearch.attr('action');
    setEvents();
  }

});



// WEBPACK FOOTER //
// ./_front/_inteligo/js/app/ajax-search.js